<template>
  <div>
    <ServerError v-if="ServerError" />
    <div class="app flex-row align-items-center">
      <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="8">
            <b-card-group>
              <b-card no-body class="p-4">
                <b-card-body>
                  <form @submit.prevent="onSubmit">
                    <h1>Login</h1>
                    <p class="text-muted">Sign In to your account</p>
                    <p v-if="msg" style="color:red;">{{msg}}</p>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-user"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        class="form-control"
                        placeholder="Username"
                        autocomplete="username email"
                        v-model="login.username"
                        required
                      />
                    </b-input-group>
                    <b-input-group class="mb-4">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="password"
                        class="form-control"
                        placeholder="Password"
                        autocomplete="current-password"
                        v-model="login.password"
                        required
                      />
                    </b-input-group>
                    <b-row>
                      <b-col cols="6">
                        <button
                          type="submit"
                          class="btn btn-info btn-sm btn-block"
                          style="color:white;font-weight:500;"
                        >Login</button>
                      </b-col>
                      <!-- <b-col cols="6" class="text-right">
                        <b-button variant="link" class="px-0">Forgot password?</b-button>
                      </b-col>-->
                    </b-row>
                  </form>
                </b-card-body>
              </b-card>
              <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
                <b-card-body class="text-center">
                  <div>
                    <h2>Indian Mammals Admin Panel</h2>
                    <p>The admin panel to monitor the day to day reports and other services with exciting features.</p>
                    <!-- <b-button variant="primary" class="active mt-3">Register Now!</b-button> -->
                  </div>
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="col-md-12">
      <!--footer-->
      <a href="#">Indian Mammals</a>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }}</span>
      <b style="float:right;">
        <span class="mr-1">Powered by</span>
        <a href="http://leopardtechlabs.com" target="_blank">Leopard Tech Labs Pvt. Ltd</a>
      </b>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "../../store";
export default {
  name: "login",
  data() {
    return {
      login: {},
      msg: null,
      appLoading: false,
      ServerError: false,
    };
  },
  methods: {
    onSubmit() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/login",
        data: this.login,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = null;
            store.commit("loginUser");
            localStorage.setItem("token", response.data.data.token);
            this.getProfile();
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          localStorage.setItem("role", response.data.data.role);
          this.$router.push("/");
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
  },
};
</script>
